import { render, staticRenderFns } from "./WhatWeDoBlock.vue?vue&type=template&id=1593b427&scoped=true"
import script from "./WhatWeDoBlock.vue?vue&type=script&lang=ts"
export * from "./WhatWeDoBlock.vue?vue&type=script&lang=ts"
import style0 from "./WhatWeDoBlock.vue?vue&type=style&index=0&id=1593b427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1593b427",
  null
  
)

export default component.exports